import {
  Control,
  Controller,
  UseFormClearErrors,
  Path,
  FieldValues,
} from "react-hook-form";
import TextField from "@carrier-io/air-react/TextField";
import React from "react";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ControllableInputProps<T extends FieldValues = any> = Omit<
  React.ComponentProps<typeof TextField>,
  "error"
> & {
  name: Path<T>;
  control: Control<T>;
  error?: string;
  clearErrors?: UseFormClearErrors<T>;
  hideHelperText?: boolean;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ControllableInput = <T extends FieldValues = any>({
  name,
  control,
  error,
  clearErrors,
  hideHelperText = false,
  helperText,
  ...props
}: ControllableInputProps<T>) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const ControllerComponent = Controller as any;
  return (
    <ControllerComponent
      name={name}
      control={control}
      render={({
        field: { name, onChange, value, ref, onBlur },
        formState: { defaultValues },
      }) => {
        return (
          <TextField
            ref={ref}
            defaultValue={defaultValues?.[name] ?? ""}
            value={value}
            onBlur={onBlur}
            onChange={(e) => onChange(e)}
            size="xlarge"
            error={!!error}
            helperText={!hideHelperText && (error || helperText)}
            onFocus={() => clearErrors && clearErrors(name)}
            {...props}
          />
        );
      }}
    />
  );
};
